import DOMPurify from 'dompurify';

/**
 * Преобразует HTML-строку в обычный текст, удаляя все HTML-теги и атрибуты.
 * Использует DOMPurify для безопасной очистки от потенциально опасного или нежелательного содержимого.
 *
 * @param {string} html - HTML-строка, содержащая разметку.
 * @returns {string} - Очищенный текст без тегов, пробелов по краям и HTML-структуры.
 *
 * @example
 * getPlainTextFromHtml('<p>Hello <strong>world</strong></p>');
 * // Вернёт: 'Hello world'
 */

export const getPlainTextFromHtml = (html: string): string => {
    const clean = DOMPurify.sanitize(html, { ALLOWED_TAGS: [], ALLOWED_ATTR: [] });
    return clean.trim();
};
